import React from 'react';
import _ from 'lodash';
import { compose } from 'redux';
import { connect } from 'react-redux';
import HeaderNotification from 'app/components/base/HeaderNotification';
import { formValueSelector } from 'redux-form';
import { preprocessTripObject } from 'app/utils/trip';
import { FormattedMessage } from 'translations';

import {
  BOOK_TRIP_FORM,
  DEPARTING_TRIP_FIELD_NAME
} from 'app/constants';


const messages = {
  freeCancellationStatus: { id: 'BOOK_TRIP.FREE_CANCELATION_STATUS' },
  cancellationOffline: { id: 'BOOK_TRIP.CANCELLATION_OFFLINE' },
  cancellationNotAllowed: { id: 'BOOK_TRIP.NO_CANCELLATION' }
};

/**
 * The component is used in BTP as a header to motivate a user
 * to book the trip
 */

const selector = formValueSelector(BOOK_TRIP_FORM);
export const mapStateToProps = state => {
  const trip = selector(state, DEPARTING_TRIP_FIELD_NAME);
  const preparedTrip = preprocessTripObject(trip);
  let freeCancellationPeriod = '';
  let cancellableOffline = false;

  if (preparedTrip) {
    freeCancellationPeriod = _.get(preparedTrip.details, 'cancellationPolicy.0.notice', '');
    cancellableOffline = _.get(preparedTrip.details, 'cancellableOffline');
  }
  return {
    freeCancellation: trip && trip.freeCancellation,
    freeCancellationPeriod,
    cancellableOffline
  };
};

export const BookHeader = ({
  titleClassName,
  statusClassName,
  freeCancellation,
  freeCancellationPeriod,
  cancellableOffline,
}) => {
  let cancellationMessage = null;
  if (freeCancellation) {
    cancellationMessage = (
      <FormattedMessage
        {...messages.freeCancellationStatus}
        values={{ period: freeCancellationPeriod }}
      />
    );
  } else if (cancellableOffline) {
    cancellationMessage = <FormattedMessage {...messages.cancellationOffline} />;
  } else {
    cancellationMessage = <FormattedMessage {...messages.cancellationNotAllowed} />;
  }

  return (
    <div>
      <HeaderNotification
        titleId={'BOOK_TRIP.ALMOST_DONE'}
        titleClassName={titleClassName}
        status={cancellationMessage}
        statusClassName={statusClassName}
        gray
      />
    </div>
  );
};

// TODO: move to Flow types
// BookHeader.propTypes = {
//   titleClassName: PropTypes.string,
//   statusClassName: PropTypes.string,
//   freeCancellation: PropTypes.bool,
//   freeCancellationPeriod: PropTypes.string,
//   cancellableOffline: PropTypes.bool,
// };

export default compose(
  connect(mapStateToProps)
)(BookHeader);
